import { render, staticRenderFns } from "./PointCreditTelecomForm.vue?vue&type=template&id=095adb53"
import script from "./PointCreditTelecomForm.vue?vue&type=script&lang=js"
export * from "./PointCreditTelecomForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports